<script setup lang="ts">
import FormPlano from '../components/form-plano.vue'
import { usePlanoStore } from '../store/usePlanoStore'

definePage({
  meta: {
    navActiveLink: 'admin-plano',
    action: 'edit',
    subject: 'plano',
  },
})

const store = usePlanoStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormPlano is-editing />
</template>
